import { useLayoutEffect } from "react";

import { syncViewportHeightNow } from "../methods/viewportSheet";

/** Re-measure sheet viewport after mount (swipeable library + full-viewport sheet). */
export const useViewportSheetDomSync = (isActive: boolean) => {
    useLayoutEffect(() => {
        if (!isActive) {
            return;
        }

        syncViewportHeightNow();
        const frameId = requestAnimationFrame(syncViewportHeightNow);

        return () => cancelAnimationFrame(frameId);
    }, [isActive]);
};
